import React from "react";
import "./App.css";
import AppRouter from "../../routes/AppRouter";
import Header from "../common/Header";
import Footer from "../common/Footer";
import FormSelection from "../FormSelection/FormSelection";

const App = () => (
  <>
    <Header />
    <div className="App container" style={{ padding: "2em" }}>
      <AppRouter />
      {/* <FormSelection /> */}
      {/* <Claims /> */}
    </div>
    <Footer />
  </>
);

export default App;
